// extracted by mini-css-extract-plugin
export var alternate = "_12-j";
export var black = "_12-6";
export var blue = "_12-f";
export var blueLight = "_12-e";
export var brand = "_12-8";
export var darkMode = "_12-b";
export var error = "_12-a";
export var gray = "_12-5";
export var grayBlue = "_12-d";
export var iconWrapper = "_12-3";
export var inactive = "_12-7";
export var indigo = "_12-g";
export var orange = "_12-i";
export var pink = "_12-h";
export var primary = "_12-0";
export var purple = "_12-9";
export var success = "_12-4";
export var warning = "_12-c";
export var white = "_12-1";
export var whiteSuccess = "_12-2";